import {
  FormItem,
  type IFormItemProps,
} from '@framework/form/item/FormItem.tsx';
import { type FieldValues } from 'react-hook-form';
import { AdvancedSearchFormItemLayout } from './AdvancedSearchFormItemLayout.tsx';

export interface IAdvancedSearchFormItemProps<T extends FieldValues>
  extends IFormItemProps<T> {}

export function AdvancedSearchFormItem<T extends FieldValues>(
  props: IAdvancedSearchFormItemProps<T>,
) {
  return <FormItem layout={AdvancedSearchFormItemLayout} {...props} />;
}
